import { useTranslation } from 'react-i18next'
import { Switch } from '@/components/v2/ui/Switch'
import { Select } from '@/components/v2/ui/Select'
import { Input } from '@/components/v2/ui/Input'
import type { SegmentTopN } from './segmentPresets'

interface SegmentTopNRowProps {
  top?: SegmentTopN
  onToggle: (enabled: boolean) => void
  onChange: (patch: Partial<SegmentTopN>) => void
}

/** Top-N row for the SegmentRuleBuilder: switch + metric select + count (1-100). */
export function SegmentTopNRow({ top, onToggle, onChange }: SegmentTopNRowProps) {
  const { t } = useTranslation()

  return (
    <div className="flex items-center gap-2 mt-1">
      <Switch
        data-testid="top-toggle"
        checked={!!top}
        onCheckedChange={onToggle}
        label={t('productSegments.top.label')}
      />
      {top && (
        <>
          <div className="w-40">
            <Select
              data-testid="top-metric"
              options={[
                { value: 'revenue_30d', label: t('productSegments.top.metricRevenue') },
                { value: 'quantity_30d', label: t('productSegments.top.metricQuantity') },
              ]}
              value={top.metric}
              onValueChange={(v) => onChange({ metric: v as SegmentTopN['metric'] })}
              aria-label={t('productSegments.top.metricLabel')}
            />
          </div>
          <div className="w-20">
            <Input
              data-testid="top-n"
              type="number"
              min={1}
              max={100}
              value={top.n}
              onChange={(e) => onChange({ n: Math.min(100, Math.max(1, Number(e.target.value))) })}
              aria-label={t('productSegments.top.nLabel')}
            />
          </div>
        </>
      )}
    </div>
  )
}

SegmentTopNRow.displayName = 'SegmentTopNRow'
